/*
* @Author: Alexander.Vangelov@vonage.com
* @Date: 2020-11-05 09:38:20
 * @Last Modified by: Alexander.Vangelov@vonage.com
 * @Last Modified time: 2024-03-15 15:33:32
*/
import { share } from './share';

require('./c2d.scss');

const observer = require('./numberParsing/nodeObserver');
let startEnabled: boolean;

let onLoad = () => {
  const webExt = (global as any).chrome || (global as any).browser
  if (!share.worker && !(window as any).__karma__) {
    if (webExt?.runtime) {
      share.sendWorkerMessage = webExt?.runtime?.sendMessage;
    } else {
      let workerOrigin = 'https://apps.gunify.vonage.com';
      if (/^https:\/\/apps\.gunify/.test(location.origin)) { // load corresponding worker in lower environments
        workerOrigin = location.origin;
      }
      const workerFile = '/cti/common/vonage.dialer.worker.js';
      const workerPath = `${workerOrigin}${workerFile}`;
      const workerBlob = new Blob([`importScripts(${JSON.stringify(workerPath)})`], { type: 'application/javascript' });
      const blobUrl = window.URL.createObjectURL(workerBlob);
      share.worker = new Worker(blobUrl);
      if (share.countryCode) {
        share.worker.postMessage(
          { action: 'vLocalCountryCode', countryCode: share.countryCode }
        );
      }
      share.sendWorkerMessage = (msg, cb) => {
        try {
          const messageChannel = new MessageChannel();
          const onPortMessage = ({ data }) => {
            if (typeof(cb) === 'function') {
              cb(data);
            }
            messageChannel.port1.removeEventListener('message', onPortMessage, false);
            messageChannel.port1.close();
          };
          messageChannel.port1.addEventListener('message', onPortMessage, false);
          messageChannel.port1.start();
          share.worker.postMessage(msg, [messageChannel.port2]);
        } catch (e) {
          cb({});
        }
      }
    }
    observer.observe(document.body, startEnabled, true); //start
  }
}

export const enableClickToDial = (enabled = true) => {
  if (!observer.toggleObserverListener) {
    startEnabled = true;
  } else {
    observer.toggleObserverListener(enabled);
  }
}

if (document.body) {
  onLoad();
} else {
  if (window.addEventListener) {
    window.addEventListener('load', onLoad)
  } else {
    (<any>window).attachEvent('onload', onLoad)
  }
}
